export enum Experiment {
  EnableCSSOptimization = 'specs.membersAboutOOI.EnableCSSOptimization',
  EnableAboutMiddleware = 'specs.membersAbout.EnableAboutMiddleware',
  EnableAccessibleRCE = 'specs.membersAbout.EnableAccessibleRCE',
  UseNewPostsCoverDefaults = 'specs.membersAbout.UseNewPostsCoverDefaults',
  EnableAboutContainerStyles = 'specs.membersAbout.EnableAboutContainerStyles',
}
